import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { TimeRangePicker } from '@/components/data-truth/TimeRangePicker'
import { CommandPalette } from './CommandPalette'
import { NotificationCenter } from './NotificationCenter'
import { PersonaIndicator } from './PersonaIndicator'
import { useShell, type Env } from './shell-context'

const ENVS: Env[] = ['prod', 'staging', 'dev']

export function TopBar() {
  const { env, setEnv, range, setRange } = useShell()

  return (
    <header className="fixed top-0 right-0 left-0 z-[500] flex h-14 items-center gap-4 border-b border-border bg-surface px-3.5">
      <div className="text-[14px] font-bold tracking-tight">
        Medhyai <span className="font-medium text-ink-2">Admin</span>
      </div>
      <div className="flex flex-1 justify-center">
        <CommandPalette />
      </div>
      <div className="flex items-center gap-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="cursor-pointer rounded-[7px] border border-border bg-canvas px-2.5 py-1.5 text-[12.5px] text-ink hover:border-accent">
              env: {env} ▾
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {ENVS.map((e) => (
              <DropdownMenuItem key={e} data-state={e === env ? 'checked' : undefined} onSelect={() => setEnv(e)}>
                {e}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

        <TimeRangePicker value={range} onChange={setRange} />

        <PersonaIndicator />

        <NotificationCenter />
      </div>
    </header>
  )
}
